import styled, { css } from 'styled-components'

import { ChevronUpIcon } from '@nx/fire/assets'
import { Body } from '@nx/fire/typography'

export const StyledContainer = styled.div`
  position: relative;
`

export const StyledChevronIcon = styled(ChevronUpIcon)<{
  $direction: 'up' | 'down'
}>`
  ${({ $direction }) => css`
    height: 15px;
    transform: rotate(${$direction === 'up' ? '0deg' : '180deg'});
    transition: rotate ease 0.3s;
    width: 15px;
  `}
`

export const StyledBody = styled(Body)`
  display: block;
`

export const StyledInput = styled.div<{ $hasError?: boolean }>`
  ${({ theme, $hasError }) => css`
    align-items: center;
    background-color: ${theme.colours.primary.white};
    border: 1px solid
      ${$hasError ? theme.colours.status.error : theme.colours.primary.black};
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    gap: 10px;
    justify-content: space-between;
    line-height: 1.4;
    padding: 5px;
    width: 100%;
  `}
`

export const StyledListContainer = styled.ul<{ $visible: boolean }>`
  display: ${({ $visible }) => ($visible ? 'block' : 'none')};
`

export const StyledList = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colours.primary.white};
    border: 1px solid ${theme.colours.primary.black};
    border-radius: 0 0 3px 3px;
    border-top: 0;
    display: flex;
    flex-direction: column;
    height: 181px;
    overflow: scroll;
    position: absolute;
    width: 100%;
    z-index: ${theme.zIndex.dropdown};
  `}
`

export const StyledListItem = styled.li<{ $disabled: boolean }>`
  ${({ theme, $disabled }) => css`
    padding: 5px;

    &:hover {
      background-color: ${theme.colours.grey['45']};
      cursor: pointer;
    }

    ${$disabled &&
    css`
      color: ${theme.colours.grey['60']};

      &:hover {
        background-color: ${theme.colours.primary.white};
        cursor: not-allowed;
      }
    `};
  `}
`
